export default __webpack_public_path__ + "static/media/opsgenie.15798a8b.svg";